/* eslint-disable no-inline-comments, capitalized-comments */

// ========================= IMPORT DEPENDENCIES ========================= //

import {bootstrap} from '@mvps-genesis/core';
import Global from 'pages/Global';

// ========================= RUN MAIN SCRIPT ========================= //

bootstrap({

	// Pass your MVT to JS namespace
	context: window.mivaJS,

	// Global Page class
	globalClass: Global,

	// A directory of page classes or scss files to be loaded by matching the `Page_Code` context variable
	pageCodeImports: {
		ABAL: () => import(/* webpackChunkName: "page-code--ABAL" */'pages/ABAL/ABAL.js'),
		ABUS: () => import(/* webpackChunkName: "page-code--ABUS" */'pages/ABUS/ABUS.js'),
		ACED: () => import(/* webpackChunkName: "page-code--ACED" */'pages/ACED/ACED.js'),
		ACLN: () => import(/* webpackChunkName: "page-code--ACLN" */'pages/ACLN/ACLN.js'),
		BASK: () => import(/* webpackChunkName: "page-code--BASK" */'pages/BASK/BASK.js'),
		CABK: () => import(/* webpackChunkName: "page-code--CABK" */'pages/CABK/CABK.js'),
		CADA: () => import(/* webpackChunkName: "page-code--CADA" */'pages/CADA/CADA.js'),
		CADE: () => import(/* webpackChunkName: "page-code--CADE" */'pages/CADE/CADE.js'),
		CARL: () => import(/* webpackChunkName: "page-code--CARL" */'pages/CARL/CARL.js'),
		CARS: () => import(/* webpackChunkName: "page-code--CARS" */'pages/CARS/CARS.js'),
		CEML: () => import(/* webpackChunkName: "page-code--CEML" */'pages/CEML/CEML.js'),
		CPCA: () => import(/* webpackChunkName: "page-code--CPCA" */'pages/CPCA/CPCA.js'),
		CPCD: () => import(/* webpackChunkName: "page-code--CPCD" */'pages/CPCD/CPCD.js'),
		CPCE: () => import(/* webpackChunkName: "page-code--CPCE" */'pages/CPCE/CPCE.js'),
		CPHS: () => import(/* webpackChunkName: "page-code--CPHS" */'pages/CPHS/CPHS.js'),
		CPNS: () => import(/* webpackChunkName: "page-code--CPNS" */'pages/CPNS/CPNS.js'),
		CPRV: () => import(/* webpackChunkName: "page-code--CPRV" */'pages/CPRV/CPRV.js'),
		CPWD: () => import(/* webpackChunkName: "page-code--CPWD" */'pages/CPWD/CPWD.js'),
		CRAE: () => import(/* webpackChunkName: "page-code--CRAE" */'pages/CRAE/CRAE.js'),
		CSBE: () => import(/* webpackChunkName: "page-code--CSBE" */'pages/CSBE/CSBE.js'),
		CSUB: () => import(/* webpackChunkName: "page-code--CSUB" */'pages/CSUB/CSUB.js'),
		CTGY: () => import(/* webpackChunkName: "page-code--CTGY" */'pages/CTGY/CTGY.js'),
		CTUS: () => import(/* webpackChunkName: "page-code--CTUS" */'pages/CTUS/CTUS.js'),
		INVC: () => import(/* webpackChunkName: "page-code--INVC" */'pages/INVC/INVC.js'),
		OCST: () => import(/* webpackChunkName: "page-code--OCST" */'pages/OCST/OCST.js'),
		OPAY: () => import(/* webpackChunkName: "page-code--OPAY" */'pages/OPAY/OPAY.js'),
		ORDH: () => import(/* webpackChunkName: "page-code--ORDH" */'pages/ORDH/ORDH.js'),
		ORDS: () => import(/* webpackChunkName: "page-code--ORDS" */'pages/ORDS/ORDS.js'),
		OSEL: () => import(/* webpackChunkName: "page-code--OSEL" */'pages/OSEL/OSEL.js'),
		PRMA: () => import(/* webpackChunkName: "page-code--PRMA" */'pages/PRMA/PRMA.js'),
		PROD: () => import(/* webpackChunkName: "page-code--PROD" */'pages/PROD/PROD.js'),
		PROD_TMP_OUTLET_MERGE: () => import(/* webpackChunkName: "page-code--PROD_TMP_OUTLET_MERGE" */'pages/PROD_TMP_OUTLET_MERGE/PROD_TMP_OUTLET_MERGE.js'),
		RETC: () => import(/* webpackChunkName: "page-code--RETC" */'pages/RETC/RETC.js'),
		RETP: () => import(/* webpackChunkName: "page-code--RETP" */'pages/RETP/RETP.js'),
		RETS: () => import(/* webpackChunkName: "page-code--RETS" */'pages/RETS/RETS.js'),
		RGFT: () => import(/* webpackChunkName: "page-code--RGFT" */'pages/RGFT/RGFT.js'),
		SARP: () => import(/* webpackChunkName: "page-code--SARP" */'pages/SARP/SARP.js'),
		SFNT: () => import(/* webpackChunkName: "page-code--SFNT" */'pages/SFNT/SFNT.js'),
		SRCH: () => import(/* webpackChunkName: "page-code--SRCH" */'pages/SRCH/SRCH.js'),
		WISH: () => import(/* webpackChunkName: "page-code--WISH" */'pages/WISH/WISH.js'),
		WLAD: () => import(/* webpackChunkName: "page-code--WLAD" */'pages/WLAD/WLAD.js'),
		WLED: () => import(/* webpackChunkName: "page-code--WLED" */'pages/WLED/WLED.js'),
		WLST: () => import(/* webpackChunkName: "page-code--WLST" */'pages/WLST/WLST.js'),
		WPCK: () => import(/* webpackChunkName: "page-code--WPCK" */'pages/WPCK/WPCK.js')
	},

	// A directory of page classes or scss files to be loaded by matching the `Screen` or `Page_Code` context variable against a regular expression
	regexImports: {},

	// A directory of page classes or scss files to be loaded by matching the `Screen` context variable
	screenImports: {}

});
